export default __webpack_public_path__ + "static/media/no_login.04fda650.png";